import React from "react";

const MailSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32.143"
      height="24.082"
      viewBox="0 0 32.143 24.082"
    >
      <g id="Mail" transform="translate(0 -5)">
        <path
          id="envelope-solid"
          d="M31.534,71.952a.378.378,0,0,1,.609.295V85.072a3.013,3.013,0,0,1-3.013,3.01H3.013A3.013,3.013,0,0,1,0,85.072V72.253a.375.375,0,0,1,.609-.295c1.406,1.091,3.271,2.477,9.674,7.124,1.325.966,3.56,3,5.788,2.985,2.241.019,4.52-2.057,5.795-2.985C28.27,74.436,30.128,73.043,31.534,71.952Zm-15.463,8.1c1.456.025,3.553-1.831,4.608-2.6,8.331-6.039,8.965-6.566,10.886-8.071a1.5,1.5,0,0,0,.578-1.185V67.01A3.013,3.013,0,0,0,29.13,64H3.013A3.013,3.013,0,0,0,0,67.01V68.2a1.509,1.509,0,0,0,.578,1.185c1.921,1.5,2.555,2.032,10.886,8.071C12.518,78.224,14.615,80.08,16.072,80.055Z"
          transform="translate(0 -59)"
          fill="#292929"
        />
      </g>
    </svg>
  );
};

export default MailSVG;
